import { render } from "./BlockServices.vue?vue&type=template&id=a36ea946&scoped=true"
import script from "./BlockServices.vue?vue&type=script&lang=js"
export * from "./BlockServices.vue?vue&type=script&lang=js"

import "./BlockServices.vue?vue&type=style&index=0&id=a36ea946&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/AcivgTheme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a36ea946"]])

export default __exports__